import { render } from "./IndvInfGthUseMtt.vue?vue&type=template&id=373b1d3c"
const script = {}

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__